<div class="flex flex-col gap-2 px-3 pb-3 pt-1 bg-gray-000 rounded-b-2xl">
	<div class="flex flex-wrap items-center justify-between gap-1">
		<span class="flex min-w-0 items-center gap-1">
			@if (symbol().icon; as icon) {
				<ui-icon width="24" height="24" class="shrink-0 text-gray-900" [iconName]="icon" />
			}
			<span class="line-clamp-2 text-sm font-bold text-gray-900">{{ symbol().name }}</span>
		</span>
		<span class="mr-auto flex shrink-0 items-center gap-1">
			<span
				class="text-xs font-medium"
				[class.text-green-500]="lastPriceUp()"
				[class.text-red-500]="!lastPriceUp()">
				<span [class.text-gray-900]="lastPriceUnchanged()"
					>(%<ui-number dir="ltr" [value]="symbol().lastPriceChangePercent" [maxDigit]="2" />)</span
				>&ngsp;<ui-number format="1.0-0" dir="ltr" [value]="symbol().lastPriceChange" />
			</span>
			<span class="text-sm font-bold text-gray-900">
				<ui-number format="1.0-0" [value]="symbol().lastPrice" />
			</span>
		</span>
	</div>
</div>
